import { Component } from '@angular/core';
import { Student } from '../student.model';
import { StudentService } from '../student.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SharedService } from '../../shared.service';
import { Router } from '@angular/router';
import { Sped360Service } from '../../../sped360/sped360.service';
import { StudentSearchComponent } from '../../student-search/student-search.component';

@Component({
    selector: 'app-student-in-focus',
    templateUrl: './student-in-focus.component.html'
})
export class StudentInFocusComponent {

    student: Student;
    constructor(
        private studentService: StudentService,
        private dialog: MatDialogRef<StudentInFocusComponent>,
        private sharedService: SharedService,
        private router: Router,
        private sped360Service: Sped360Service,
        private matDialog: MatDialog
    ) {
        this.student = this.studentService.selectedStudent;
    }

    clearFocus() {
        if (this.router.url.indexOf('/student360') > -1 || this.router.url.indexOf('/programAndServices/singleStudent') > -1 || this.router.url.indexOf('/health360/studentHealth') > -1) {
            this.router.navigateByUrl('/classroom360/cards');
        }
        if (this.router.url == '/sped360/studentDocumentHome' || this.router.url.indexOf('/sped360/spedFormsWithinDocuments') > -1 || this.router.url.indexOf('/specialServiceEvaluations/viewEditEvaluationReport') > -1) {
            if (this.sped360Service.spedFixedPermission.ViewSpEdHome == true || this.sped360Service.spedFixedPermission.ViewSpecialServicesHome == true) {
                this.router.navigateByUrl('/sped360/spedHome');
            } else {
                const dialogBox = this.matDialog.open(StudentSearchComponent, {
                    data: {
                        performRoute: true,
                        searchAndSelect: false,
                        redirectUrl: '/sped360/studentDocumentHome'
                    },
                    width: '100%',
                    height: '100%',
                    maxHeight: '100vh',
                    maxWidth: '100vw'
                });
                dialogBox.afterClosed().subscribe(data => {
                    if (data == undefined) {
                        this.router.navigateByUrl('/classroom360/cards');
                    }
                });
            }
        }
        this.studentService.selectedStudent = undefined;
        this.studentService.updateSelectedStudent(undefined);
        this.closeClick();
    }

    closeClick() {
        this.dialog.close();
    }
}
